export enum PessoaOrigemEnum {
    /* Do not change order: used by ordinal value */
    MJ,
    GOV_BR_CPF,
    GOV_BR_CNPJ,
    ESTRANGEIRO
}
